{
  "(未知发件人)": "(unknown sender)",
  "(无主题)": "(no subject)",
  "{account} 收到 {n} 封新邮件": "{account} received {n} new messages",
  "{email} 收不到邮件了": "{email} can no longer receive mail",
  "{email} 已添加到馍馍邮箱": "{email} has been added to Momomail",
  "{key} 格式不对": "Invalid {key}",
  "{names}\n最新：{subject}": "{names}\nLatest: {subject}",
  "备注格式不对": "Invalid note",
  "本机": "This computer",
  "本机登录请在原来的工具里管理；要在这里另外登录，请选\"网页登录\"。": "Manage local logins in the original tool; to sign in separately here, choose \"Web login\".",
  "本机连接用的是系统里的 API Key；要换 Key 请用\"输入 API Key\"。": "Local connections use the API key from this system; to use a different key, choose \"Enter API key\".",
  "本机没有这个 API Key。": "This machine doesn't have this API key.",
  "本机模式 / 命令行没有个人账号": "Local mode / the command line has no personal account",
  "本机模式没有多用户": "Local mode does not have multiple users",
  "本机已经检测不到这个 AI 的登录或 API Key，请重新检测，或者网页登录 / 填写 API Key。": "This AI's login or API key can no longer be found on this machine. Detect again, or sign in on the web / enter an API key.",
  "标题格式不对": "Invalid title",
  "不能删除本机用户": "The local user can't be deleted",
  "不能删除自己": "You can't delete yourself",
  "不能停用自己或取消自己的管理员": "You can't disable yourself or remove your own admin rights",
  "不支持这个方法": "Method not supported",
  "参数不对": "Invalid parameters",
  "操作范围格式不对": "Invalid action scope",
  "操作格式不对": "Invalid action",
  "草稿 id格式不对": "Invalid draft id",
  "草稿格式不对": "Invalid draft",
  "代码格式不对": "Invalid code",
  "代码格式不对，请从授权页面完整复制。": "Invalid code format. Please copy it completely from the authorization page.",
  "当前密码不对": "The current password is incorrect",
  "当前密码格式不对": "Invalid current password",
  "地点格式不对": "Invalid location",
  "地址格式不对": "Invalid address",
  "登录超时了，请重新开始。": "Login timed out. Please start again.",
  "登录没有成功，请重新登录。": "Login did not succeed. Please sign in again.",
  "登录失败：用户名或密码（授权码）不对，或者服务器没有开启 IMAP/SMTP。": "Login failed: wrong username or password (authorization code), or IMAP/SMTP is not enabled on the server.",
  "登录已失效，请重新网页登录。": "The login has expired. Please sign in on the web again.",
  "端口应该是 1–65535 的整数": "The port must be an integer from 1 to 65535",
  "发件账户不存在": "The sending account does not exist",
  "发件账户格式不对": "Invalid sending account",
  "发送失败：{error}": "Sending failed: {error}",
  "发信服务器地址格式不对": "Invalid outgoing server address",
  "发信服务器的加密方式不对": "Invalid encryption setting for the outgoing server",
  "发信服务器端口格式不对": "Invalid outgoing server port",
  "发信服务器格式不对": "Invalid outgoing server",
  "分页格式不对": "Invalid pagination",
  "服务拒绝访问（403），请检查账户权限。": "Access denied (403). Please check the account permissions.",
  "服务器的 Google Cloud 项目没有启用 Google Calendar API，请管理员在 Google Cloud 控制台里启用。": "The server's Google Cloud project hasn't enabled the Google Calendar API. Ask the administrator to enable it in the Google Cloud console.",
  "服务器拒绝连接：请检查端口和加密方式。": "The server refused the connection: check the port and encryption setting.",
  "服务器连不上 AI 服务，请稍后重试。": "The server can't reach the AI service. Please try again later.",
  "服务器没有配置 FCM（MOMOMAIL_FCM_SERVICE_ACCOUNT_FILE）": "The server has no FCM configured (MOMOMAIL_FCM_SERVICE_ACCOUNT_FILE)",
  "服务器没有配置 Google OAuth 客户端（MOMOMAIL_GOOGLE_CLIENT_ID / MOMOMAIL_GOOGLE_CLIENT_SECRET），只能用应用专用密码。": "The server has no Google OAuth client configured (MOMOMAIL_GOOGLE_CLIENT_ID / MOMOMAIL_GOOGLE_CLIENT_SECRET). Only app passwords can be used.",
  "服务器没有配置 Google OAuth 客户端（MOMOMAIL_GOOGLE_CLIENT_ID / SECRET），这个账户收不了信。": "The server has no Google OAuth client configured (MOMOMAIL_GOOGLE_CLIENT_ID / SECRET), so this account cannot receive mail.",
  "服务器没有配置 Google OAuth，没法直接写 Google 日历。": "The server has no Google OAuth configured, so it can't write to Google Calendar.",
  "服务器没有配置公开网址 MOMOMAIL_PUBLIC_URL，发不了重置密码邮件，所以暂时不能邀请新用户。": "The server has no public URL configured (MOMOMAIL_PUBLIC_URL), so it cannot send password reset emails. Inviting new users is unavailable for now.",
  "服务器上没有装这个 AI 的命令行，请联系管理员。": "This AI's command-line tool is not installed on the server. Please contact the administrator.",
  "服务器上没有装这个 AI 的命令行，请联系管理员（见部署说明\"AI\"一节）。": "This AI's command-line tool is not installed on the server. Please contact the administrator (see the \"AI\" section of the deployment guide).",
  "服务器上找不到这封邮件了": "This message can no longer be found on the server",
  "附件\"{name}\"要先上传": "The attachment \"{name}\" must be uploaded first",
  "附件\"{name}\"已经不在服务器上了，请重新添加": "The attachment \"{name}\" is no longer on the server. Please add it again",
  "附件不存在": "Attachment not found",
  "附件大小格式不对": "Invalid attachment size",
  "附件格式不对": "Invalid attachment",
  "附件类型格式不对": "Invalid attachment type",
  "附件名格式不对": "Invalid attachment name",
  "附件太大：单个文件最多 {mb} MB": "Attachment too large: each file can be at most {mb} MB",
  "管理员还没有设置系统发信邮箱（设置 → 用户管理），设置好之后才能邀请新用户，这样大家忘了密码能自己找回。": "The administrator has not set a system sending mailbox yet (Settings → Users). New users can be invited once it is set, so everyone can reset a forgotten password themselves.",
  "还没有连接 Google 日历。": "Google Calendar is not connected yet.",
  "还没有选择可用的 AI：请到 设置 → AI 登录或填写 API Key。": "No usable AI selected yet: go to Settings → AI to sign in or enter an API key.",
  "后端返回 {status}": "The server returned {status}",
  "后端返回 HTTP {status}": "The server returned HTTP {status}",
  "后端没有接好授权保存。": "The server is not set up to save the authorization.",
  "后端内部错误": "Internal server error",
  "回调地址没有在 Google Cloud 里登记：请管理员在 OAuth 客户端里加上 {uri}": "The redirect URI is not registered in Google Cloud: ask the administrator to add {uri} to the OAuth client",
  "回调网址格式不对": "Invalid callback URL",
  "回复没有发出去：{error}": "The response was not sent: {error}",
  "回复信息格式不对": "Invalid reply info",
  "回复已发出，但没能更新 Google 日历：{error}": "The response was sent, but Google Calendar could not be updated: {error}",
  "回复只能是接受、暂定或拒绝": "The response must be accept, tentative or decline",
  "加密连接失败：请检查加密方式（SSL/TLS 或 STARTTLS）和端口是否对应。": "Secure connection failed: check that the encryption (SSL/TLS or STARTTLS) matches the port.",
  "结束时间不能早于开始时间": "The end time cannot be before the start time",
  "结束时间格式不对": "Invalid end time",
  "开始时间格式不对": "Invalid start time",
  "看不懂粘贴的内容：请复制跳转之后地址栏里的完整网址。": "Can't understand what was pasted: copy the full URL from the address bar after the redirect.",
  "连不上 Google 日历：{error}": "Can't reach Google Calendar: {error}",
  "连不上 Google 授权服务器：{error}": "Can't reach Google's authorization server: {error}",
  "连接超时：网络不通或者服务器没有响应。": "Connection timed out: the network is down or the server is not responding.",
  "连接断开": "Disconnected",
  "连接中断了，稍后会自动重连。": "The connection dropped. It will reconnect automatically.",
  "没有勾选\"查看和修改日历活动\"，请重新授权并勾选。": "The \"See and edit events on your calendars\" permission was not checked. Please authorize again and check it.",
  "没有勾选\"读取、撰写、发送和永久删除您在 Gmail 中的所有电子邮件\"，请重新授权并勾选。": "The \"Read, compose, send and permanently delete all your email from Gmail\" permission was not checked. Please authorize again and check it.",
  "没有连接这个 Google 日历": "This Google Calendar is not connected",
  "没有配置加密密钥，无法安全保存密码。": "No encryption key is configured, so passwords cannot be saved securely.",
  "没有配置加密密钥，无法安全保存密钥。": "No encryption key is configured, so secrets cannot be saved securely.",
  "没有配置加密密钥，无法读取已保存的密码。": "No encryption key is configured, so saved passwords cannot be read.",
  "没有配置加密密钥，无法读取已保存的密钥。": "No encryption key is configured, so saved secrets cannot be read.",
  "没有写日历的权限，请重新连接 Google 日历并勾选\"查看和修改日历活动\"。": "No permission to write to the calendar. Reconnect Google Calendar and check \"See and edit events on your calendars\".",
  "没有用户 {name}": "No user named {name}",
  "没有粘贴内容。": "Nothing was pasted.",
  "没有这个接口": "No such endpoint",
  "没有这个用户": "No such user",
  "密码 / 应用密码": "Password / app password",
  "密码错误次数太多，请过几分钟再试": "Too many failed attempts. Please try again in a few minutes",
  "密码格式不对": "Invalid password",
  "密码或授权码不对了（可能改过密码），打开馍馍邮箱重新填写。": "The password or authorization code no longer works (it may have been changed). Open Momomail and enter it again.",
  "密码太长": "Password is too long",
  "密码至少 8 个字符": "Passwords must be at least 8 characters",
  "密钥格式不对": "Invalid secret format",
  "名字格式不对": "Invalid name",
  "馍馍邮箱": "Momomail",
  "馍馍邮箱测试推送": "Momomail test notification",
  "模型格式不对": "Invalid model",
  "模型名称太长。": "The model name is too long.",
  "目标文件夹不存在": "Target folder not found",
  "目标文件夹格式不对": "Invalid target folder",
  "内容格式不对": "Invalid content",
  "你同时让 AI 做的事太多了，请稍后再试。": "You have too many AI tasks running at once. Please try again later.",
  "凭证不是本版本的加密格式": "The credentials are not in this version’s encryption format",
  "凭证格式不对": "Invalid credential format",
  "其他 IMAP 邮箱": "Other IMAP mail",
  "千问 3.5 Flash": "Qwen 3.5 Flash",
  "千问 3.5 Plus": "Qwen 3.5 Plus",
  "千问 API Key": "Qwen API Key",
  "千问 VL Plus": "Qwen VL Plus",
  "签名格式不对": "Invalid signature",
  "请求格式不对": "Invalid request",
  "请求太大": "Request too large",
  "请求体不是合法的 JSON": "The request body is not valid JSON",
  "请求体应该是 JSON": "The request body must be JSON",
  "请输入内容。": "Please enter some content.",
  "请填写 API Key。": "Please enter an API key.",
  "请填写标题": "Please enter a title",
  "请填写密码或授权码": "Please enter a password or authorization code",
  "请填写模型名称。": "Please enter a model name.",
  "请填写收信和发信服务器": "Please enter the incoming and outgoing servers",
  "请填写用户名": "Please enter a username",
  "请填写找回邮箱：忘记密码时重置链接会发到这里": "Please enter a recovery email: password reset links are sent there",
  "请先添加一个邮箱账户": "Please add a mail account first",
  "请先填写 API Key。": "Please enter an API key first.",
  "请先填写这个 AI 的 API Key。": "Please enter this AI's API key first.",
  "请先网页登录。": "Please sign in on the web first.",
  "请先选择一个已经登录或填好 API Key 的 AI。": "Please choose an AI that is signed in or has an API key first.",
  "请选择官方 API 地址。": "Please choose an official API URL.",
  "请用管理员自己的账号登录后设置": "Please sign in with your own administrator account to set this",
  "请用用户自己的登录会话登记设备": "Please register the device with the user's own login session",
  "请至少填一个收件人": "Please add at least one recipient",
  "全天格式不对": "Invalid all-day",
  "日程格式不对": "Invalid event",
  "如果你看到这条，推送是通的。": "If you can see this, push notifications are working.",
  "上下文长度格式不对": "Invalid context length",
  "上下文长度要在 8000 到 2000000 之间。": "The context length must be between 8000 and 2000000.",
  "设备格式不对": "Invalid device",
  "设备名格式不对": "Invalid device name",
  "时区格式不对": "Invalid time zone",
  "收件人地址不对：{address}": "Invalid recipient address: {address}",
  "收件人地址有问题": "Problem with a recipient address",
  "收件人地址有问题：{detail}": "Problem with a recipient address: {detail}",
  "收件人格式不对": "Invalid recipients",
  "收信服务器地址格式不对": "Invalid incoming server address",
  "收信服务器的加密方式不对": "Invalid encryption setting for the incoming server",
  "收信服务器端口格式不对": "Invalid incoming server port",
  "收信服务器格式不对": "Invalid incoming server",
  "手动填写收信（IMAP）和发信（SMTP）服务器。服务器地址一般在邮箱网页版的设置或帮助里能找到。": "Enter the incoming (IMAP) and outgoing (SMTP) servers manually. You can usually find the server addresses in your mail provider's web settings or help pages.",
  "手机": "Phone",
  "授权不存在或已过期（30 分钟），请重新开始。": "The authorization does not exist or has expired (30 minutes). Please start again.",
  "授权的是 {granted}，不是这个账户的 {email}，请用对应的 Google 账号登录。": "You authorized {granted}, not this account ({email}). Please sign in with the matching Google account.",
  "授权格式不对": "Invalid authorization",
  "授权码": "Authorization code",
  "授权码无效或已经用过了，请重新开始授权。": "The authorization code is invalid or already used. Please start the authorization again.",
  "授权没有通过（代码不对或已过期），请重新登录。": "Authorization failed (the code is wrong or expired). Please sign in again.",
  "授权没有完成": "Authorization not completed",
  "授权失败": "Authorization failed",
  "授权完成": "Authorization complete",
  "授权已过期（30 分钟），请重新开始。": "The authorization has expired (30 minutes). Please start again.",
  "授权用途不对": "Invalid authorization purpose",
  "数量格式不对": "Invalid count",
  "说明格式不对": "Invalid description",
  "搜索词格式不对": "Invalid search query",
  "搜索结果不能在服务器上全部标为已读": "Search results can't be marked read on the server",
  "推送地址格式不对": "Invalid push endpoint",
  "推送地址只能是 http(s)": "The push endpoint must be http(s)",
  "推送公钥格式不对": "Invalid push public key",
  "推送密钥格式不对": "Invalid push secret",
  "网页登录不用填 API Key。": "Web login doesn't need an API key.",
  "网页上不能直接设别人的密码，请发邀请链接": "You can't set another user's password here. Send them an invite link instead",
  "网易 163 邮箱": "NetEase 163 Mail",
  "网址里没有 code：请复制浏览器跳转之后地址栏里的完整网址。": "The URL has no code: copy the full URL from the address bar after the browser redirects.",
  "微软已逐步关闭密码登录（基本身份验证），很多账户只能用 OAuth 登录，这个版本还不支持。如果你的组织仍允许 IMAP 密码登录，可以先试试。": "Microsoft is phasing out password login (basic authentication); many accounts can only use OAuth, which this version does not support yet. If your organization still allows IMAP password login, you can try it.",
  "未知错误": "Unknown error",
  "未知的 AI 连接": "Unknown AI connection",
  "文件夹不存在": "Folder not found",
  "文件夹格式不对": "Invalid folder",
  "无法解密已保存的密码：加密密钥和保存时的不一样。请恢复原来的密钥，或者重新填写账户密码。": "Can't decrypt the saved password: the encryption key differs from the one used to save it. Restore the original key or re-enter the account password.",
  "系统里的 {label}": "{label} from this system",
  "系统里的登录已失效：请在原来的工具里重新登录（比如运行 claude 后 /login），或者在这里改用网页登录。": "The login on this system has expired: sign in again in the original tool (e.g. run claude, then /login), or use web login here instead.",
  "显示名格式不对": "Invalid display name",
  "现在没有在登录。": "No login is in progress.",
  "写信方式不对": "Invalid compose mode",
  "新密码格式不对": "Invalid new password",
  "需要登录": "Login required",
  "需要先开启两步验证，再在 Google 账号里生成\"应用专用密码\"（16 位）。普通登录密码不能用。": "Turn on 2-Step Verification first, then create an \"App password\" (16 characters) in your Google Account. Your normal password will not work.",
  "颜色格式不对": "Invalid color",
  "邀请格式不对": "Invalid invite",
  "邀请链接无效或已经过期，请找管理员重新要一个。": "The invite link is invalid or has expired. Please ask the administrator for a new one.",
  "已登录": "Signed in",
  "已登录的 {tool}": "Signed-in {tool}",
  "引用格式不对": "Invalid quoted text",
  "引用信息格式不对": "Invalid references",
  "应用专用密码": "App password",
  "用户 {name} 已停用": "User {name} is disabled",
  "用户格式不对": "Invalid user",
  "用户名 {name} 已经有人用了": "The username {name} is already taken",
  "用户名 2–32 个字符，只能用字母、数字、汉字和 . _ -": "Usernames must be 2–32 characters: letters, digits, Chinese characters and . _ -",
  "用户名格式不对": "Invalid username",
  "用户名或密码不对": "Incorrect username or password",
  "用户名或邮箱格式不对": "Invalid username or email",
  "邮件 id格式不对": "Invalid message id",
  "邮件不存在": "Message not found",
  "邮件不存在或已被移走": "The message no longer exists or has been moved",
  "邮件格式不对": "Invalid message",
  "邮件已发出，但没能存进\"已发送\"：{error}": "The message was sent, but could not be saved to \"Sent\": {error}",
  "邮件已发出；这个账户没有\"已发送\"文件夹，没有留底。": "The message was sent; this account has no \"Sent\" folder, so no copy was kept.",
  "邮箱地址格式不对": "Invalid email address",
  "邮箱范围格式不对": "Invalid mailbox scope",
  "邮箱格式不对": "Invalid email",
  "有 {n} 封新邮件": "{n} new messages",
  "有多个用户：请用 --user 指定是谁的": "There are multiple users: use --user to choose one",
  "有一封新邮件": "1 new message",
  "原邮件格式不对": "Invalid original message",
  "在 account.apple.com 的\"登录与安全 → App 专用密码\"里生成一个，填在这里。": "Generate one at account.apple.com under \"Sign-In and Security → App-Specific Passwords\" and enter it here.",
  "在 Google 页面上取消了授权。": "Authorization was cancelled on the Google page.",
  "在 QQ 邮箱网页版\"设置 → 账号\"里开启 IMAP/SMTP 服务，按提示生成授权码，填在这里（不是 QQ 密码）。": "In QQ Mail on the web, enable IMAP/SMTP under \"Settings → Account\", generate an authorization code as prompted and enter it here (not your QQ password).",
  "在网页版\"设置 → POP3/SMTP/IMAP\"里开启 IMAP/SMTP 服务并设置客户端授权码。126、yeah.net 请把服务器里的 163 换成对应域名。": "On the web, enable IMAP/SMTP under \"Settings → POP3/SMTP/IMAP\" and set a client authorization code. For 126 or yeah.net, replace 163 in the server names with that domain.",
  "账户 id格式不对": "Invalid account id",
  "账户不存在": "Account not found",
  "账户额度已用完或请求太频繁，请检查用量后再试。": "The account quota is used up or requests are too frequent. Please check usage and try again.",
  "账户格式不对": "Invalid account",
  "账户名格式不对": "Invalid account name",
  "账户同步已停止": "Account sync stopped",
  "找不到服务器：请检查服务器地址和网络连接。": "Server not found: check the server address and your network connection.",
  "找回邮箱格式不对": "Invalid recovery email",
  "这不是本机连接。": "This is not a local connection.",
  "这封邀请里没有组织者，没法回复。": "This invitation has no organizer, so it can't be answered.",
  "这封邮件里没有会议邀请": "This message has no meeting invitation",
  "这个 Kimi 账户的套餐没有开通 Kimi Code（新版套餐需要 Plus 或以上）。": "This Kimi account's plan doesn't include Kimi Code (new plans need Plus or higher).",
  "这个后端不用密码登录": "This server does not use password login",
  "这个活动已经取消了。": "This event has been cancelled.",
  "这个来源不允许访问": "Access from this origin is not allowed",
  "这个连接用 API Key。": "This connection uses an API key.",
  "这个模型不可用，请换一个模型。": "This model is unavailable. Please choose another one.",
  "这个授权链接已经过期或无效，请回到馍馍邮箱重新开始。": "This authorization link has expired or is invalid. Please go back to Momomail and start again.",
  "这个网址不是这次授权的（state 对不上），请用刚才给出的授权网址重新来一遍。": "This URL isn't from this authorization (state mismatch). Please start again with the authorization URL just given.",
  "这个邀请不需要回复。": "This invitation doesn't need a response.",
  "这个账户还没有保存密码。": "No password has been saved for this account yet.",
  "这个账户没有归档文件夹": "This account has no archive folder",
  "这个账户没有垃圾邮件文件夹": "This account has no spam folder",
  "正文格式不对": "Invalid body",
  "只能选你自己名下的邮箱账户": "You can only choose a mail account that belongs to you",
  "只有管理员能做这个": "Only administrators can do this",
  "至少要留一个管理员": "There must be at least one administrator",
  "重置链接格式不对": "Invalid reset link",
  "重置链接无效或已经过期，请重新申请。": "The reset link is invalid or has expired. Please request a new one.",
  "主题格式不对": "Invalid subject",
  "AI 服务连接失败": "Failed to connect to the AI service",
  "AI 回答超时了，请重试。": "The AI timed out. Please try again.",
  "AI 没有正常回答，请检查登录 / API Key、额度和网络后重试。": "The AI didn't answer properly. Check the login / API key, quota and network, then try again.",
  "AI 设置格式不对": "Invalid AI settings",
  "API 地址格式不对": "Invalid API URL",
  "API Key 不对或没有权限，请检查后重新填写。": "The API key is wrong or lacks permission. Please check it and enter it again.",
  "API Key 不对或已失效，请检查后重新填写。": "The API key is wrong or has expired. Please check it and enter it again.",
  "API Key 格式不对。": "Invalid API key format.",
  "App 专用密码": "App-specific password",
  "Claude 网页登录（已有套餐）": "Claude web login (existing plan)",
  "Claude Code 登录": "Claude Code login",
  "Claude Code 配置里的 Key": "Key from Claude Code settings",
  "Codex 登录": "Codex login",
  "Codex 配置里的 Key": "Key from Codex settings",
  "Codex 网页登录（已有套餐）": "Codex web login (existing plan)",
  "FCM 服务账号换令牌失败：{error}": "FCM service account token exchange failed: {error}",
  "FCM 令牌格式不对": "Invalid FCM token",
  "Google 返回错误：{error}": "Google returned an error: {error}",
  "Google 没有返回 refresh token，请到 Google 账号的\"第三方应用\"里移除这个应用后重新授权。": "Google did not return a refresh token. Remove this app under \"Third-party apps\" in your Google Account, then authorize again.",
  "Google 没有返回授权码。": "Google did not return an authorization code.",
  "Google 没有返回邮箱地址（缺少 email 权限）。": "Google did not return an email address (the email permission is missing).",
  "Google 日历出错（{status}）：{error}": "Google Calendar error ({status}): {error}",
  "Google 日历授权已失效，请重新连接 Google 日历。": "Google Calendar authorization has expired. Please reconnect Google Calendar.",
  "Google 日历已连接": "Google Calendar connected",
  "Google 授权失败：{error}": "Google authorization failed: {error}",
  "Google 授权已失效，打开馍馍邮箱重新用 Google 登录。": "Google authorization has expired. Open Momomail and sign in with Google again.",
  "Google 授权已失效（被撤销、改了 Google 密码，或者 OAuth 应用还在\"测试\"状态 7 天到期），请重新用 Google 登录。": "Google authorization has expired (revoked, Google password changed, or the OAuth app is still in \"Testing\" and expired after 7 days). Please sign in with Google again.",
  "Google OAuth 客户端配置不对：请检查 MOMOMAIL_GOOGLE_CLIENT_ID / MOMOMAIL_GOOGLE_CLIENT_SECRET。": "The Google OAuth client is misconfigured: check MOMOMAIL_GOOGLE_CLIENT_ID / MOMOMAIL_GOOGLE_CLIENT_SECRET.",
  "iCloud 邮件": "iCloud Mail",
  "Kimi 的 5 小时窗口用量已耗尽，请等窗口重置后再试。": "Kimi's 5-hour usage window is used up. Please try again after it resets.",
  "Kimi 的本月额度已耗尽。": "Kimi's monthly quota is used up.",
  "Kimi 的周额度已耗尽，请等额度重置后再试。": "Kimi's weekly quota is used up. Please try again after it resets.",
  "Kimi 登录": "Kimi login",
  "Kimi 网页登录（已有套餐）": "Kimi web login (existing plan)",
  "Kimi API Key（推荐）": "Kimi API Key (recommended)",
  "OAuth 授权失败": "OAuth authorization failed",
  "QQ 邮箱": "QQ Mail",
  "手机没有确认收到（断线了？重连时会补发）": "The phone didn’t confirm receipt (disconnected?); it will be resent on reconnect",
  "未知的用途。": "Unknown purpose.",
  "未知的用途": "Unknown purpose",
  "这个 AI 还没有登录或填写 API Key。": "This AI isn't signed in and has no API key yet.",
  "还没有为这件事选择 AI：请到 设置 → AI 选择。": "No AI has been picked for this yet: choose one in Settings → AI.",
  "为这件事选的 AI 已经退出登录，请到 设置 → AI 重新登录或换一个。": "The AI picked for this has been signed out: sign in again or pick another in Settings → AI.",
  "AI 的回答看不懂，这一批没有打上标签。": "The AI's answer couldn't be understood, so this batch wasn't tagged.",
  "已退订": "Unsubscribed",
  "这封邮件没有退订链接": "This message has no unsubscribe link",
  "正在退订，请稍等": "Already unsubscribing, please wait",
  "这封邮件的退订方式用不了": "This message's unsubscribe method can't be used",
  "退订邮箱地址不对": "The unsubscribe email address is invalid",
  "已发退订邮件给 {to}": "Unsubscribe email sent to {to}",
  "需要你在网页上完成退订": "Please finish unsubscribing on the web page",
  "还没有可用的 AI，请在网页上完成退订": "No AI is available yet: please finish unsubscribing on the web page",
  "退订网页打不开，请在浏览器里试试": "The unsubscribe page couldn't be opened; try it in your browser",
  "步骤太多，请在网页上确认是否已退订": "That took too many steps; please check on the web page whether you're unsubscribed",
  "这个地址指向内部网络，不能打开": "This address points to an internal network and can't be opened",
  "链接格式不对": "The link is malformed",
  "只能打开网页链接": "Only web links can be opened",
  "不打开非标准端口的链接": "Links on non-standard ports aren't opened",
  "不打开带账号密码的链接": "Links with a username or password aren't opened",
  "跳转次数太多": "Too many redirects",
  "网页打开超时": "The page took too long to open",
  "馍馍正在忙，等它做完再清空": "Momo is busy; clear the chat when it's done",
  "请输入内容": "Please type something",
  "馍馍还在处理上一件事，请稍等": "Momo is still working on the last thing; please wait",
  "这个操作已经不在了": "This action is gone",
  "已发送": "Sent",
  "已删除": "Deleted",
  "分类规则已更新": "Tagging rules updated",
  "发送失败": "Sending failed",
  "需要发邮件给 {to} 退订，请在这封邮件里点\"退订\"确认": "Unsubscribing needs an email to {to}; tap \"Unsubscribe\" in that message to confirm",
  "重要": "Important",
  "垃圾": "Junk",
  "标签已更新": "Tags updated",
  "已经退订过这个发件人": "Already unsubscribed from this sender",
  "馍馍正在忙，等它做完或按\"停止\"": "Momo is busy: wait until it is done, or press \"Stop\""
}
